
/* -- THIS IS A GENERATED FILE BY @relay -- */
import { ComponentRegistration } from '@relay/client';

export const registrations: ComponentRegistration[] = [
{
  name: 'TopicHeader',
  import: (): Promise<any> => import('C:/agent/_work/14000/s/src/ui/src/stories/widgets/TopicHeader/TopicHeader.client'),
  config: {
  hydrate: 'in-view',
},
},
  {
  name: 'TestimonialCarousel',
  import: (): Promise<any> => import('C:/agent/_work/14000/s/src/ui/src/stories/widgets/TestimonialCarousel/TestimonialCarousel.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'TabbedContentCarousel',
  import: (): Promise<any> => import('C:/agent/_work/14000/s/src/ui/src/stories/widgets/TabbedContentCarousel/TabbedContentCarousel.client'),
  config: {
  hydrate: 'in-view',
},
},
  {
  name: 'StepByStep',
  import: (): Promise<any> => import('C:/agent/_work/14000/s/src/ui/src/stories/widgets/StepByStep/StepByStep.client'),
  config: {
  hydrate: 'in-view',
},
},
  {
  name: 'Statistics',
  import: (): Promise<any> => import('C:/agent/_work/14000/s/src/ui/src/stories/widgets/Statistics/Statistics.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'ServiceSignpost',
  import: (): Promise<any> => import('C:/agent/_work/14000/s/src/ui/src/stories/widgets/ServiceSignpost/ServiceSignpost.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'SearchListing',
  import: (): Promise<any> => import('C:/agent/_work/14000/s/src/ui/src/stories/widgets/SearchListing/SearchListing.client'),
  config: {
  hydrate: 'always',
},
},
  {
  name: 'MultipleClickThroughCards',
  import: (): Promise<any> => import('C:/agent/_work/14000/s/src/ui/src/stories/widgets/MultipleClickThroughCards/MultipleClickThroughCards.client'),
  config: {
  hydrate: 'in-view',
},
},
  {
  name: 'LocationsSignposting',
  import: (): Promise<any> => import('C:/agent/_work/14000/s/src/ui/src/stories/widgets/LocationsSignposting/LocationsSignposting.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'LocationListing',
  import: (): Promise<any> => import('C:/agent/_work/14000/s/src/ui/src/stories/widgets/LocationListing/LocationListing.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'LawyerSearch',
  import: (): Promise<any> => import('C:/agent/_work/14000/s/src/ui/src/stories/widgets/LawyerSearch/LawyerSearch.client'),
  config: {
  hydrate: 'in-view',
},
},
  {
  name: 'LawyerListing',
  import: (): Promise<any> => import('C:/agent/_work/14000/s/src/ui/src/stories/widgets/LawyerListing/LawyerListing.client'),
  config: {
  hydrate: 'always',
},
},
  {
  name: 'LawyerCarousel',
  import: (): Promise<any> => import('C:/agent/_work/14000/s/src/ui/src/stories/widgets/LawyerCarousel/LawyerCarousel.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'HeroBanner',
  import: (): Promise<any> => import('C:/agent/_work/14000/s/src/ui/src/stories/widgets/HeroBanner/HeroBanner.client'),
  config: {
  hydrate: 'always',
},
},
  {
  name: 'InternalNav',
  import: (): Promise<any> => import('C:/agent/_work/14000/s/src/ui/src/stories/widgets/InternalNav/InternalNav.client'),
  config: {
  hydrate: 'in-view',
},
},
  {
  name: 'FiftyFifty',
  import: (): Promise<any> => import('C:/agent/_work/14000/s/src/ui/src/stories/widgets/FiftyFifty/FiftyFifty.client'),
  config: {
  hydrate: 'in-view',
},
},
  {
  name: 'ContentListing',
  import: (): Promise<any> => import('C:/agent/_work/14000/s/src/ui/src/stories/widgets/ContentListing/ContentListing.client'),
  config: {
  hydrate: 'always',
},
},
  {
  name: 'ContentHeroComponents',
  import: (): Promise<any> => import('C:/agent/_work/14000/s/src/ui/src/stories/widgets/ContentHeroComponents/ContentHeroComponents.client'),
  config: {
  hydrate: 'in-view',
},
},
  {
  name: 'CaseStudyCarousel',
  import: (): Promise<any> => import('C:/agent/_work/14000/s/src/ui/src/stories/widgets/CaseStudyCarousel/CaseStudyCarousel.client'),
  config: {
  hydrate: 'in-view',
},
},
  {
  name: 'Accordions',
  import: (): Promise<any> => import('C:/agent/_work/14000/s/src/ui/src/stories/widgets/Accordions/Accordions.client'),
  config: {
  hydrate: 'in-view',
},
},
  {
  name: 'AccreditationLogos',
  import: (): Promise<any> => import('C:/agent/_work/14000/s/src/ui/src/stories/widgets/AccreditationLogos/AccreditationLogos.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'RelatedContentGroup',
  import: (): Promise<any> => import('C:/agent/_work/14000/s/src/ui/src/stories/widgets/RelatedContent/RelatedContentGroup/RelatedContentGroup.client'),
  config: {
  hydrate: 'in-view',
},
},
  {
  name: 'Header',
  import: (): Promise<any> => import('C:/agent/_work/14000/s/src/ui/src/stories/widgets/Global/Header/Header.client'),
  config: {
  hydrate: 'always',
},
},
  {
  name: 'Footer',
  import: (): Promise<any> => import('C:/agent/_work/14000/s/src/ui/src/stories/widgets/Global/Footer/Footer.client'),
  config: {
  hydrate: 'in-view',
},
},
  {
  name: 'Button',
  import: (): Promise<any> => import('C:/agent/_work/14000/s/src/ui/src/stories/components/buttons/Button/Button.client'),
  config: {
  hydrate: 'click',
},
},
  {
  name: 'ShareButtons',
  import: (): Promise<any> => import('C:/agent/_work/14000/s/src/ui/src/stories/components/misc/ShareButtons/ShareButtons.client'),
  config: {
  hydrate: 'in-view',
},
},
  {
  name: 'LoadingOverlay',
  import: (): Promise<any> => import('C:/agent/_work/14000/s/src/ui/src/stories/components/misc/LoadingOverlay/LoadingOverlay.client'),
  config: {
  hydrate: 'in-view',
},
},
  {
  name: 'FormRow',
  import: (): Promise<any> => import('C:/agent/_work/14000/s/src/ui/src/stories/components/misc/forms/FormRow.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'FormField',
  import: (): Promise<any> => import('C:/agent/_work/14000/s/src/ui/src/stories/components/misc/forms/FormField.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'Form',
  import: (): Promise<any> => import('C:/agent/_work/14000/s/src/ui/src/stories/components/misc/forms/Form.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'IntroBlock',
  import: (): Promise<any> => import('C:/agent/_work/14000/s/src/ui/src/stories/components/misc/IntroBlock/IntroBlock.client'),
  config: {
  hydrate: 'in-view',
},
},
  {
  name: 'AccordionComponent',
  import: (): Promise<any> => import('C:/agent/_work/14000/s/src/ui/src/stories/components/misc/AccordionComponent/AccordionComponent.client'),
  config: {
  hydrate: 'click',
},
},
  {
  name: 'ContentBadge',
  import: (): Promise<any> => import('C:/agent/_work/14000/s/src/ui/src/stories/components/misc/ContentBadge/ContentBadge.client'),
  config: {
  hydrate: 'in-view',
},
},
  {
  name: 'ServiceSignpostCard',
  import: (): Promise<any> => import('C:/agent/_work/14000/s/src/ui/src/stories/components/cards/ServiceSignpostCard/ServiceSignpostCard.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'SecondaryNavigation',
  import: (): Promise<any> => import('C:/agent/_work/14000/s/src/ui/src/stories/widgets/Global/Header/SecondaryNavigation/SecondaryNavigation.client'),
  config: {
  hydrate: 'always',
},
},
  {
  name: 'SearchOverlay',
  import: (): Promise<any> => import('C:/agent/_work/14000/s/src/ui/src/stories/widgets/Global/Header/SearchOverlay/SearchOverlay.client'),
  config: {
  hydrate: 'always',
},
},
  {
  name: 'NavigationBlock',
  import: (): Promise<any> => import('C:/agent/_work/14000/s/src/ui/src/stories/widgets/Global/Header/NavigationBlock/NavigationBlock.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'Navigation',
  import: (): Promise<any> => import('C:/agent/_work/14000/s/src/ui/src/stories/widgets/Global/Header/Navigation/Navigation.client'),
  config: {
  hydrate: 'always',
},
},
  {
  name: 'RichTextBlock',
  import: (): Promise<any> => import('C:/agent/_work/14000/s/src/ui/src/stories/widgets/ContentHeroComponents/Blocks/RichTextBlock/RichTextBlock.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'MediaBlock',
  import: (): Promise<any> => import('C:/agent/_work/14000/s/src/ui/src/stories/widgets/ContentHeroComponents/Blocks/MediaBlock/MediaBlock.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'IconGridBlock',
  import: (): Promise<any> => import('C:/agent/_work/14000/s/src/ui/src/stories/widgets/ContentHeroComponents/Blocks/IconGridBlock/IconGridBlock.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'Pagination',
  import: (): Promise<any> => import('C:/agent/_work/14000/s/src/ui/src/stories/components/misc/listings/Pagination/Pagination.client'),
  config: {
  hydrate: 'in-view',
},
},
  {
  name: 'ResultsHeader',
  import: (): Promise<any> => import('C:/agent/_work/14000/s/src/ui/src/stories/components/misc/listings/ResultsHeader/ResultsHeader.client'),
  config: {
  hydrate: 'in-view',
},
},
  {
  name: 'FilterBar',
  import: (): Promise<any> => import('C:/agent/_work/14000/s/src/ui/src/stories/components/misc/listings/FilterBar/FilterBar.client'),
  config: {
  hydrate: 'in-view',
},
},
  {
  name: 'DropdownFilter',
  import: (): Promise<any> => import('C:/agent/_work/14000/s/src/ui/src/stories/components/misc/listings/DropdownFilter/DropdownFilter.client'),
  config: {
  hydrate: 'in-view',
},
},
  {
  name: 'Item',
  import: (): Promise<any> => import('C:/agent/_work/14000/s/src/ui/src/stories/components/misc/AccordionComponent/Item/Item.client'),
  config: {
  hydrate: 'click',
},
},
  {
  name: 'FullWidthCarousel',
  import: (): Promise<any> => import('C:/agent/_work/14000/s/src/ui/src/stories/components/misc/carousels/FullWidthCarousel/FullWidthCarousel.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'TestimonialBlock',
  import: (): Promise<any> => import('C:/agent/_work/14000/s/src/ui/src/stories/widgets/Global/Header/NavigationBlock/TestimonialBlock/TestimonialBlock.client'),
  config: {
  hydrate: 'always',
},
},
  {
  name: 'StatisticsBlock',
  import: (): Promise<any> => import('C:/agent/_work/14000/s/src/ui/src/stories/widgets/Global/Header/NavigationBlock/StatisticsBlock/StatisticsBlock.client'),
  config: {
  hydrate: 'always',
},
},
  {
  name: 'StandardBlock',
  import: (): Promise<any> => import('C:/agent/_work/14000/s/src/ui/src/stories/widgets/Global/Header/NavigationBlock/StandardBlock/StandardBlock.client'),
  config: {
  hydrate: 'always',
},
},
  {
  name: 'LocationMenuBlock',
  import: (): Promise<any> => import('C:/agent/_work/14000/s/src/ui/src/stories/widgets/Global/Header/NavigationBlock/LocationMenuBlock/LocationMenuBlock.client'),
  config: {
  hydrate: 'always',
},
},
  {
  name: 'LocationMapBlock',
  import: (): Promise<any> => import('C:/agent/_work/14000/s/src/ui/src/stories/widgets/Global/Header/NavigationBlock/LocationMapBlock/LocationMapBlock.client'),
  config: {
  hydrate: 'always',
},
},
  {
  name: 'LawyerSearchBlock',
  import: (): Promise<any> => import('C:/agent/_work/14000/s/src/ui/src/stories/widgets/Global/Header/NavigationBlock/LawyerSearchBlock/LawyerSearchBlock.client'),
  config: {
  hydrate: 'always',
},
},
  {
  name: 'InterlawIntroBlock',
  import: (): Promise<any> => import('C:/agent/_work/14000/s/src/ui/src/stories/widgets/Global/Header/NavigationBlock/InterlawIntroBlock/InterlawIntroBlock.client'),
  config: {
  hydrate: 'always',
},
},
  {
  name: 'Textbox',
  import: (): Promise<any> => import('C:/agent/_work/14000/s/src/ui/src/stories/components/misc/forms/inputs/Textbox/Textbox.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'Textarea',
  import: (): Promise<any> => import('C:/agent/_work/14000/s/src/ui/src/stories/components/misc/forms/inputs/Textarea/Textarea.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'Recaptcha2',
  import: (): Promise<any> => import('C:/agent/_work/14000/s/src/ui/src/stories/components/misc/forms/inputs/Recaptcha2/Recaptcha2.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'RadioList',
  import: (): Promise<any> => import('C:/agent/_work/14000/s/src/ui/src/stories/components/misc/forms/inputs/RadioList/RadioList.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'Select',
  import: (): Promise<any> => import('C:/agent/_work/14000/s/src/ui/src/stories/components/misc/forms/inputs/Select/Select.client'),
  config: {
  hydrate: 'always',
},
},
  {
  name: 'CheckboxList',
  import: (): Promise<any> => import('C:/agent/_work/14000/s/src/ui/src/stories/components/misc/forms/inputs/CheckboxList/CheckboxList.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'Progress',
  import: (): Promise<any> => import('C:/agent/_work/14000/s/src/ui/src/stories/components/misc/carousels/Carousel/Progress/Progress.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'Pagination',
  import: (): Promise<any> => import('C:/agent/_work/14000/s/src/ui/src/stories/components/misc/carousels/Carousel/Pagination/Pagination.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'LiveRegion',
  import: (): Promise<any> => import('C:/agent/_work/14000/s/src/ui/src/stories/components/misc/carousels/Carousel/LiveRegion/LiveRegion.client'),
  config: {
    hydrate: 'in-view',
  },
},
  {
  name: 'Controls',
  import: (): Promise<any> => import('C:/agent/_work/14000/s/src/ui/src/stories/components/misc/carousels/Carousel/Controls/Controls.client'),
  config: {
    hydrate: 'in-view',
  },
} 
];
  